var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.3de01ba124ede6802a745eb9d9bf528f.svg#H';
                    var viewUrl = 'sprites.3de01ba124ede6802a745eb9d9bf528f.svg#view-H';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 2110 359.6',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };